import spanishLocale from 'date-fns/locale/es';
import englishLocale from 'date-fns/locale/en-US';

import i18n from '../i18n';

const Locales = {
    en: englishLocale,
    es: spanishLocale
};

export const getCurrentLocale = () => {
    return Locales?.[i18n.language.split('-')[0] as 'en' | 'es'] ?? englishLocale;
};
